import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import {
  checkSuper,
  checkAdmin,
  checkNoClient,
  checkClient,
  checkNoSupervisor,
} from '../../helpers/auth';

import AppContext from '../../store/App/contexts';

// Layout
import Layout from '../../components/Layout';

// Login
import Login from '../Login';
import AdminLogin from '../Login/Admin';
import ClientLogin from '../Login/Client';
import SupervisorLogin from '../Login/Supervisor';
import ForgotPassword from '../Login/ForgotPassword';
import ResetPassword from '../Login/ResetPassword';
import SetupAccount from '../Login/SetupAccount';

// Live Dashboard
import LiveDashboard from './LiveDashboard';

// User Management
import AdminManagement from './UserManagement/Admins';
import AdminDetail from './UserManagement/Admins/AdminDetail';
import AddAdmin from './UserManagement/Admins/AddAdmin';
import EditAdmin from './UserManagement/Admins/EditAdmin';
import ClientManagement from './UserManagement/Clients';
import ClientDetail from './UserManagement/Clients/ClientDetail';
import AddClient from './UserManagement/Clients/AddClient';
import EditClient from './UserManagement/Clients/EditClient';
import SiteDetail from './UserManagement/Clients/SiteDetail';
import EditSite from './UserManagement/Clients/EditSite';
import AddSite from './UserManagement/Clients/AddSite';
import AssociateManagement from './UserManagement/Associates';
import AssociateDetail from './UserManagement/Associates/AssociateDetail';
import EditAssociate from './UserManagement/Associates/EditAssociate';
import AddAssociate from './UserManagement/Associates/AddAssociate';
import SupervisorManagement from './UserManagement/Supervisors';
import SupervisorDetail from './UserManagement/Supervisors/SupervisorDetail';
import EditSupervisor from './UserManagement/Supervisors/EditSupervisor';
import AddSupervisor from './UserManagement/Supervisors/AddSupervisor';
import AddClientUser from './UserManagement/Clients/ClientDetail/ClientUsers/AddClientUser';
import EditClientUser from './UserManagement/Clients/ClientDetail/ClientUsers/EditClientUser';

// Pulse Survey
import EditPulse from './PulseSurvey/EditPulse';

//
import SmartScheduler from './SmartScheduler';

//ArtTest change here
import ArtTest from './ArtTest';
// Trouble Ticketing
import TroubleTicketing from './TroubleTicketing';
import AddTT from './TroubleTicketing/AddTT';
import TTDetail from './TroubleTicketing/TTDetail';
import AddTTGroup from './TroubleTicketing/AddTTGroup';
import EditTTGroup from './TroubleTicketing/EditTTGroup';

// Performance Management
import PerformanceManagement from './PerformanceManagement';
import LogDetail from './PerformanceManagement/LogDetail';
import ManagePerformance from './PerformanceManagement/Manage';

// Communication
import Communication from './Communication';
import AddInstruction from './Communication/AddInstruction';
import InstructionDetail from './Communication/InstructionDetail';
import FeedbackDetail from './Communication/FeedbackDetail';

// Events
import Events from './Events';
import AddEvent from './Events/AddEvent';
import EventDetail from './Events/EventDetail';
import EditEvent from './Events/EditEvent';

// Rewards
import Rewards from './Rewards';
import AddItem from './Rewards/AddItem';
import EditItem from './Rewards/EditItem';
import ItemDetail from './Rewards/ItemDetail';
import CollectionManagement from './Rewards/Collection';
import CollectionDetail from './Rewards/CollectionDetail';

//  eDocs
import EDocs from './EDocs';
import AddDoc from './EDocs/AddDoc';
import EditDoc from './EDocs/EditDoc';
import PreviewDoc from './EDocs/PreviewDoc';

// Claims
import Claims from './Claims';
import AddClaim from './Claims/AddClaim';
import EditClaim from './Claims/EditClaim';
import ClaimsApproval from './Claims/Approval';
import EditApprovalClaim from './Claims/Approval/EditClaim';

// Leaves
import Leaves from './Leaves';
import AddLeave from './Leaves/AddLeave';
import EditLeave from './Leaves/EditLeave';
import LeavesApproval from './Leaves/Approval';
import EditApprovalLeave from './Leaves/Approval/EditLeave';

import LeaveCreditsFilling from './LeaveCreditsFilling';

// Setting
import Setting from './Setting';

// Setting
import Notifications from './Notifications';

// Catalogue
import Catalogue from './Catalogue';
import AddCatalogue from './Catalogue/AddCatalogue';
import EditCatalogue from './Catalogue/EditCatalogue';

// Esign Documents
import EsignDocument from './EsignDocument';
import AddEsignDocument from './EsignDocument/AddEsignDocument';
import EditEsignDocument from './EsignDocument/EditEsignDocument';

// Delivery Order
import DeliveryOrder from './DeliveryOrder';
import AddDeliveryOrder from './DeliveryOrder/AddDeliveryOrder';
import EditDeliveryOrder from './DeliveryOrder/EditDeliveryOrder';

import ToastNotification from '../../components/ToastNotification';

const ManpowerWeb = () => {
  const access = JSON.parse(localStorage.getItem('access'));

  return (
    <AppContext.Consumer>
      {({ isLoggedIn, logoutHandler, checkTokenHandler, type, user }) => (
        <Router>
          <ToastNotification />

          <Switch>
            <Route
              path="/"
              exact
              component={() => {
                return !isLoggedIn ? (
                  <Redirect to="/login" />
                ) : (
                  <Layout user={user} type={type}>
                    <LiveDashboard />
                  </Layout>
                );
              }}
            />

            {/* Login Router */}
            <Route
              path="/login"
              exact
              component={() => {
                return isLoggedIn ? <Redirect to="/" /> : <AdminLogin />;
              }}
            />

            <Route
              path="/forgot-password/:type"
              exact
              component={ForgotPassword}
            />

            <Route
              path="/:type/resetpassword"
              exact
              component={ResetPassword}
            />

            <Route path="/setupaccount" exact component={SetupAccount} />

            {isLoggedIn && (
              <Layout user={user} type={type}>
                <Route
                  path="/logout"
                  exact
                  component={() => {
                    logoutHandler();
                    return <Redirect to="/" />;
                  }}
                />

                {checkTokenHandler() && (
                  <React.Fragment>
                    {/* Live Dashboard Router */}
                    <Route
                      path="/live-dashboard"
                      exact
                      component={LiveDashboard}
                    />

                    {/* User Management Router */}
                    {checkSuper(type) && (
                      <React.Fragment>
                        <Route
                          path="/admins"
                          exact
                          component={AdminManagement}
                        />

                        <Route
                          path="/admins/:admin_id"
                          exact
                          component={AdminDetail}
                        />
                        <Route
                          path="/admins/admin/add"
                          exact
                          component={AddAdmin}
                        />
                        <Route
                          path="/admins/admin/:admin_id/edit"
                          exact
                          component={EditAdmin}
                        />
                      </React.Fragment>
                    )}
                    {checkAdmin(type) && (
                      <React.Fragment>
                        <Route
                          path="/clients"
                          exact
                          component={ClientManagement}
                        />
                        <Route
                          path="/clients/client/:client_id"
                          exact
                          component={ClientDetail}
                        />
                        <Route
                          path="/clients/client/:client_id/pulse"
                          exact
                          component={EditPulse}
                        />
                        <Route
                          path="/clients/add"
                          exact
                          component={AddClient}
                        />
                        <Route
                          path="/clients/client/:client_id/edit"
                          component={EditClient}
                        />
                        <Route
                          path="/clients/client/:client_id/sites/site/:site_id"
                          exact
                          component={SiteDetail}
                        />
                        <Route
                          path="/clients/client/:client_id/sites/add"
                          exact
                          component={AddSite}
                        />
                        <Route
                          path="/clients/client/:client_id/sites/site/:site_id/edit"
                          component={EditSite}
                        />
                        <Route
                          path="/clients/client/:client_id/sites/site/:site_id/ttgroups/add"
                          component={AddTTGroup}
                        />
                        <Route
                          path="/clients/client/:client_id/sites/site/:site_id/ttgroups/ttgroup/:ttgroup_id"
                          component={EditTTGroup}
                        />
                        <Route
                          path="/supervisors"
                          exact
                          component={SupervisorManagement}
                        />
                        <Route
                          path="/supervisors/supervisor/:supervisor_id"
                          exact
                          component={SupervisorDetail}
                        />
                        <Route
                          path="/supervisors/add"
                          exact
                          component={AddSupervisor}
                        />
                        <Route
                          path="/supervisors/supervisor/:supervisor_id/edit"
                          component={EditSupervisor}
                        />
                        <Route
                          path="/clients/client/:client_id/admins/admin/add"
                          exact
                          component={AddClientUser}
                        />
                        <Route
                          path="/clients/client/:client_id/admins/admin/:admin_id/edit"
                          exact
                          component={EditClientUser}
                        />
                      </React.Fragment>
                    )}
                    {checkNoClient(type) && (
                      <React.Fragment>
                        <Route
                          path="/associates"
                          exact
                          component={AssociateManagement}
                        />
                        <Route
                          path="/associates/associate/:associate_id"
                          exact
                          component={AssociateDetail}
                        />
                        <Route
                          path="/associates/add"
                          exact
                          component={AddAssociate}
                        />
                        <Route
                          path="/associates/associate/:associate_id/edit"
                          component={EditAssociate}
                        />
                      </React.Fragment>
                    )}

                    {/* Smart Scheduler Router */}
                    {access
                      ? access.enable_smart_scheduler && (
                          <Route
                            path="/smart-scheduler"
                            exact
                            component={SmartScheduler}
                          />
                        )
                      : null}
                    {/* Trouble Ticketing Router */}
                    {access
                      ? access.enable_trouble_ticketing && (
                          <Route
                            path="/trouble-ticketing"
                            exact
                            component={TroubleTicketing}
                          />
                        )
                      : null}

                    {access
                      ? access.enable_trouble_ticketing && (
                          <Route
                            path="/trouble-ticketing/detail/:tt_id"
                            exact
                            component={TTDetail}
                          />
                        )
                      : null}

                    {checkNoClient(type) && (
                      // temp: removed access for client
                      <React.Fragment>
                        {access
                          ? access.enable_trouble_ticketing && (
                              <Route
                                path="/trouble-ticketing/add"
                                exact
                                component={AddTT}
                              />
                            )
                          : null}

                        {/* Performance Management Router */}
                        {access
                          ? access.enable_performance_management && (
                              <>
                                <Route
                                  path="/performance-management"
                                  exact
                                  component={PerformanceManagement}
                                />
                                <Route
                                  path="/performance-management/logs/:log_id"
                                  exact
                                  component={LogDetail}
                                />
                                <Route
                                  path="/performance-management/manage/:associate_id"
                                  exact
                                  component={ManagePerformance}
                                />
                              </>
                            )
                          : null}

                        {/* Communiction Router */}
                        {access
                          ? access.enable_communication && (
                              <>
                                <Route
                                  path="/communication"
                                  exact
                                  component={Communication}
                                />
                                <Route
                                  path="/communication/instruction/add"
                                  exact
                                  component={AddInstruction}
                                />
                                <Route
                                  path="/communication/instructions/:instruction_id"
                                  exact
                                  component={InstructionDetail}
                                />
                                <Route
                                  path="/communication/feedbacks/:feedback_id"
                                  exact
                                  component={FeedbackDetail}
                                />
                              </>
                            )
                          : null}

                        {/* Events Router */}
                        {access
                          ? access.enable_event && (
                              <>
                                {' '}
                                <Route
                                  path="/events"
                                  exact
                                  component={Events}
                                />
                                <Route
                                  path="/events/add"
                                  exact
                                  component={AddEvent}
                                />
                                <Route
                                  path="/events/event/:event_id"
                                  exact
                                  component={EventDetail}
                                />
                                <Route
                                  path="/events/event/:event_id/edit"
                                  exact
                                  component={EditEvent}
                                />{' '}
                              </>
                            )
                          : null}

                        {/* Rewards Router */}
                        {access
                          ? access.enable_reward && (
                              <>
                                <Route
                                  path="/rewards"
                                  exact
                                  component={Rewards}
                                />
                                <Route
                                  path="/rewards/add"
                                  exact
                                  component={AddItem}
                                />
                                <Route
                                  path="/rewards/item/:item_id"
                                  exact
                                  component={ItemDetail}
                                />
                                <Route
                                  path="/rewards/item/:item_id/edit"
                                  exact
                                  component={EditItem}
                                />
                                <Route
                                  path="/rewards/collections"
                                  exact
                                  component={CollectionManagement}
                                />
                                <Route
                                  path="/rewards/collection/:cart_id"
                                  exact
                                  component={CollectionDetail}
                                />
                              </>
                            )
                          : null}

                        {/* eDocs Router */}
                        {access
                          ? access.enable_edocs && (
                              <>
                                <Route path="/edocs" exact component={EDocs} />
                                <Route
                                  path="/edocs/add"
                                  exact
                                  component={AddDoc}
                                />
                                <Route
                                  path="/edocs/doc/:doc_id/edit"
                                  exact
                                  component={EditDoc}
                                />
                                <Route
                                  path="/edocs/preview"
                                  exact
                                  component={PreviewDoc}
                                />
                              </>
                            )
                          : null}

                        {/* eSign Docs Router */}
                        {access
                          ? access.enable_esign_doc && (
                              <>
                                <Route
                                  path="/esign_document"
                                  exact
                                  component={EsignDocument}
                                />
                                <Route
                                  path="/esign_document/add"
                                  exact
                                  component={AddEsignDocument}
                                />
                                <Route
                                  path="/esign_document/edit/:esign_document_id"
                                  exact
                                  component={EditEsignDocument}
                                />
                              </>
                            )
                          : null}

                        {/* Catalogue Router */}
                        {access
                          ? access.enable_catalogue && (
                              <>
                                <Route
                                  path="/catalogue"
                                  exact
                                  component={Catalogue}
                                />
                                <Route
                                  path="/catalogue/add"
                                  exact
                                  component={AddCatalogue}
                                />
                                <Route
                                  path="/catalogue/edit/:catalogue_id"
                                  exact
                                  component={EditCatalogue}
                                />
                              </>
                            )
                          : null}

                        {/* Delivery Order Router */}
                        {access
                          ? access.enable_delivery_order && (
                              <>
                                <Route
                                  path="/delivery-order"
                                  exact
                                  component={DeliveryOrder}
                                />
                                <Route
                                  path="/delivery-order/add"
                                  exact
                                  component={AddDeliveryOrder}
                                />
                                <Route
                                  path="/delivery-order/edit/:do_id"
                                  exact
                                  component={EditDeliveryOrder}
                                />
                              </>
                            )
                          : null}
                      </React.Fragment>
                    )}

                    {access
                      ? access.enable_claims && (
                          <>
                            <Route path="/claims" exact component={Claims} />
                            <Route
                              path="/claim/add"
                              exact
                              component={AddClaim}
                            />
                            <Route
                              path="/claim/edit/:claim_id"
                              exact
                              component={EditClaim}
                            />
                            <Route
                              path="/claims/approval"
                              exact
                              component={ClaimsApproval}
                            />
                            <Route
                              path="/claim/approval/edit/:claim_id/approver/:num"
                              exact
                              component={EditApprovalClaim}
                            />
                          </>
                        )
                      : null}

                    {/* Leave Credits and Filling */}
                    {access
                      ? access.enable_leave_credits && (
                          <>
                            <Route path="/leaves" exact component={Leaves} />
                            <Route
                              path="/leave/add"
                              exact
                              component={AddLeave}
                            />
                            <Route
                              path="/leave/edit/:leave_id"
                              exact
                              component={EditLeave}
                            />
                            <Route
                              path="/leaves/approval"
                              exact
                              component={LeavesApproval}
                            />
                            <Route
                              path="/leave/approval/edit/:leave_id/approver/:num"
                              exact
                              component={EditApprovalLeave}
                            />
                          </>
                        )
                      : null}

                    <Route
                      path="/notifications"
                      exact
                      component={Notifications}
                    />

                    {/* SettingRouter */}
                    {checkNoSupervisor(type) && (
                      <Route path="/setting" exact component={Setting} />
                    )}
                  </React.Fragment>
                )}
              </Layout>
            )}

            <Redirect to="/" />
          </Switch>
        </Router>
      )}
    </AppContext.Consumer>
  );
};

export default ManpowerWeb;
